import { Box } from '@veracity/vui';

const HomePage = () => {
  return (
    <Box p={4} flexDirection="column" maxW="100%" mx="auto" overflow="hidden" w="100%">
      
      <Box flexDirection="column">
        <h1>Maritime Checklist - Demo Application</h1>
        <p>
          This is a demonstration application developed as a student project over a six-month period, 
          designed to streamline maritime operations through digital checklists and compliance tracking.
        </p>
        <p>
          The Maritime Checklist app provides a comprehensive solution for maritime professionals to 
          manage safety inspections, maintenance schedules, and regulatory compliance requirements. 
          Built with a focus on the unique needs of the maritime industry, this demo showcases how 
          digital tools can replace traditional paper-based checklists while ensuring nothing falls 
          through the cracks.
        </p>
      </Box>
    </Box>
  );
};

export default HomePage;